export default __webpack_public_path__ + "static/media/two.1f68c07b.png";